trail_plan_handler = {

    properties: {
        title: 'Trail Plan'
    },

    onLoad: function(){
        var self = this;

    },

    loadData: function(){
        var self = this;

        //Load Existing Data
        if (!mapData.geoJSON.existingtrail){
            mapData.geoJSON.existingtrail = new L.GeoJSON.AJAX(["data/existing-trails.geojson?ver=061917"],{
                clickable: true,
                onEachFeature: self.existingtrailPopUp,
                style: {
                    color: '#289c3a',
                    weight: 3,
                    opacity: 1,
                    className: "existingtrail"
                }
            });
        };


        //Load Planned Data
        if (!mapData.geoJSON.plannedtrail){
            mapData.geoJSON.plannedtrail = new L.GeoJSON.AJAX(["data/planned-trails.geojson?ver=061917"],{
                clickable: true,
                onEachFeature: self.plannedtrailPopUp,
                style: {
                    color: '#828464',
                    weight: 3,
                    dashArray: "3,5",
                    opacity: 1,
                    className: "plannedtrail"
                }
            });
        };

        mapData.geoJSON.existingtrail.addTo(mapData.geoJSONLayer);
        mapData.geoJSON.plannedtrail.addTo(mapData.geoJSONLayer);


        

    },

    cleargeoJSONLayer: function(){
        mapData.geoJSONLayer.clearLayers();
    },

    existingtrailPopUp: function(f,l){
        var self = this;
        var properties = l.feature.properties;

        var id = properties.id;
        var leaflet_id = l._leaflet_id;

        l.setStyle({
            id: id,
            type: 'existingtrail',
            leaflet_id: leaflet_id
        });

        mapData.geoJSONData.existingtrail[id] = properties;


        l.on('click', function(e) {
            console.log(e);
            home_handler.onPolylineClick(e.latlng, e.layer);
        });

    },

    plannedtrailPopUp: function(f,l){
        var self = this;
        var properties = l.feature.properties;

        var id = properties.id;
        var leaflet_id = l._leaflet_id;

        l.setStyle({
            id: id,
            type: 'plannedtrail',
            leaflet_id: leaflet_id
        });

        mapData.geoJSONData.plannedtrail[id] = properties;

        l.on('click', function(e) {
            console.log(e);
            home_handler.onPolylineClick(e.latlng, e.layer);
        });


    },

    events: function() {
        var self = this;
        self.onLoad();
    }
}